<template>
    <v-form v-model="isValidForm" :disabled="isFormDisabled" lazy-validation ref="feedbackForm">
        <v-container v-if="questions.length">
            <div class="feedback-header">Оставить отзыв</div>
            <div class="feedback-subheader">На ремонт от {{dateFormatted}}</div>
            <div class="feedback-text mt-4">Оцените обслуживание по следующим критериям</div>
            <div class="d-flex flex-wrap feedback-question" :style="isMobile ? 'gap: 0px' : 'gap: 60px'">
                <div
                    v-for="question in questions"
                    cols="12"
                    :key="question.id"
                    :style="question.type !== 'number' || isMobile ? 'flex-basis: 100%;' : ''"
                >
                    <template v-if="question.type === 'number'">
                        <div class="feedback-question-name mt-4">
                            {{ question.name }}
                        </div>
                        <div>
                            <v-rating
                                v-model="answersModel[question.id]"
                                color="#2C3E84"
                                background-color="#2C3E84"
                                size="30"
                            />
                        </div>
                        <div class="rating-text">{{getRatingText(answersModel[question.id])}}</div>
                    </template>
                    <template v-if="question.type === 'string'">
                        <v-text-field
                            v-model="answersModel[question.id]"
                            :label="question.name"
                            persistent-hint
                        />
                    </template>
                    <template v-if="question.type === 'text'">
                        <div class="feedback-question-text">{{ question.name }}</div>
                        <v-textarea
                            v-model="answersModel[question.id]"
                            placeholder="Здесь можно рассказать о впечатлениях от ремонта или о том, что мы могли бы улучшить в нашем сервисе "
                        />
                    </template>
                    <template v-if="question.type === 'boolean'">
                        <v-checkbox
                            v-model="answersModel[question.id]"
                            :label="question.name"
                            persistent-hint
                        />
                    </template>
                    <template v-if="question.type === 'date'">
                        Datepicker
                    </template>
                </div>
            </div>
            <div class="mt-4 mx-2">
            <v-btn
                class="order-btn"
                color="secondary"
                :disabled="!isValidForm || isFormDisabled"
                :loading="isSending"
                @click="sendAnswers()">
                Отправить отзыв
            </v-btn>
            </div>
        </v-container>
        <v-container v-else>
            <v-row>
                <v-col cols="auto">
                    Выберите другой заказ-наряд для оценки
                </v-col>
            </v-row>
        </v-container>
    </v-form>
</template>

<script>
    import { forEach as _forEach } from 'lodash'
    import moment from 'moment'
    import { mapGetters, mapState } from 'vuex'

    export default {
        name: 'HistoryFeedbackScreen',

        data: () => ({
            answersModel: {},

            isValidForm: true,
            rules: {
                required: (value) => !!value || 'Обязательное поле.',
                string: (value) => (!!value && !!value.length) || 'Обязательное поле.',
            },
        }),

        computed: {
            ...mapState('feedback', {
                isSending: (state) => state.isSending,
            }),

            ...mapGetters({
                getQuestionsByDate: 'feedback/getQuestionsByDate',
                getOrder: 'carHistory/getCarHistoryItem',
            }),

            orderId() {
                return this.$route.params?.orderId
            },

            order() {
                return this.getOrder(this.orderId)
            },

            dateFormatted() {
                const unix = this.order?.date

                if (unix) {
                    return moment.unix(unix).utcOffset(5).locale('ru').format('LLL')
                } else {
                    return null
                }
            },

            isFormDisabled() {
                return (this.orderId && !this.order) || this.isSending || !this.questions.length
            },

            questions() {
                const questions = this.getQuestionsByDate(this.order?.date)

                _forEach(questions, (item) => {
                    const items = []
                    let i
                    for (i = 1; i <= item.maxScore; i++) {
                        items.push({
                            value: i,
                            text: i,
                        })
                    }

                    item.items = items
                })

                return questions
            },

            answers() {
                const answers = []

                _forEach(this.answersModel, (result, id) => {
                    answers.push({ id, result })
                })

                return answers
            },

            isMobile() {
                return this.$vuetify.breakpoint.smAndDown
            },
        },

        mounted() {
            this.$store.dispatch('feedback/fetch')
        },

        methods: {
            sendAnswers() {
                if (this.$refs.feedbackForm.validate()) {
                    const orderId = this.order?.id
                    const orderDate = this.order?.date
                    const date = moment().utcOffset(5).unix()
                    const answers = this.answers

                    const params = {
                        orderId,
                        orderDate,
                        date,
                        answers,
                    }

                    this.$store.dispatch('feedback/sendAnswers', params)
                        .then(() => {
                            this.$root.pushNotification({
                                text: 'Отзыв принят',
                                color: 'success',
                            })

                            this.$router.back()
                        })
                        .catch(() => {
                            this.$root.pushNotification({
                                text: 'Ошибка',
                                color: 'error',
                            })
                        })
                }
            },
            getRatingText(rating) {
                const ratingText = {
                    1: 'Очень плохо',
                    2: 'Плохо',
                    3: 'Не очень',
                    4: 'Хорошо',
                    5: 'Отлично',
                }
                return ratingText[rating] || ' '
            },
        },
    }
</script>

<style scoped>
    .feedback-header {
        font-size: 28px;
        font-weight: 600;
    }
    .mobile .feedback-header {
        font-size: 20px;
        font-weight: 600;
    }
    .feedback-subheader {
        font-size: 16px;
        font-weight: 500;
    }
    .mobile .feedback-subheader {
        font-size: 14px;
        font-weight: 500;
    }
    .feedback-text {
        font-size: 22px;
        font-weight: 600;
    }
    .mobile .feedback-text {
        font-size: 16px;
        font-weight: 600;
    }
    .feedback-question-name {
        font-size: 18px;
        font-weight: 600;
    }
    .mobile .feedback-question-name {
        font-size: 14px;
        font-weight: 600;
    }
    .rating-text {
        font-size: 16px;
        font-weight: 500;
    }
    .mobile .rating-text {
        font-size: 14px;
        font-weight: 500;
    }
    .feedback-question-text {
        font-size: 22px;
        font-weight: 600;
    }
    .mobile .feedback-question-text {
        font-size: 16px;
        font-weight: 600;
    }
    .order-btn {
        display: flex;
        padding: 16px 40px;
        justify-content: center;
        align-items: center;
        gap: 10px;
        border-radius: 10px;
        border: 2px solid #DA251C !important;
        background: #DA251C !important;
        width: 253px;
        height: 52px;
        color: #FFF;
        font-size: 16px;
        font-style: normal;
        font-weight: 600;
        line-height: normal;
        /* width: 100% !important; */
    }
    .mobile .order-btn {
        width: 100% !important;
    }
</style>

<style>
    .feedback-question .v-text-field__slot {
        border: solid 1px #F3F4F4;
        border-radius: 8px;
        max-width: 500px;
    }
    .feedback-question .v-input__slot::before {
        border: none !important;
        caret-color: #F3F4F4;
    }
    .feedback-question .v-input__slot::after {
        border: none !important;
        caret-color: #F3F4F4;
    }
</style>
